import { useState, useEffect, useCallback } from "react";
import { Breadcrumb, Button, Divider, Flex, Pagination, Table } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { HOST } from '../../const'; // Импортируем HOST
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import RGL, { WidthProvider, Responsive } from "react-grid-layout";
import { v4 as uuidv4 } from 'uuid';
import { getToken } from '../../authorization/auth'
import { useParams } from 'react-router-dom';
const ResponsiveReactGridLayout = WidthProvider(Responsive);

const CollageEdit = (props) => {
    const params = useParams();

    const [layouts, setLayouts] = useState({});  // Store layouts for different breakpoints
    const [layout, setLayout] = useState([]);
    const [xlayout, setxLayout] = useState([]);
    const [images, setImages] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newItemImage, setNewItemImage] = useState(null);
    const [newItemId, setNewItemId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);  // Стартовая страница = 0
    const [imagesPerPage] = useState(8);  // Количество изображений на одной странице
    const [uploadedImage, setUploadedImage] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [idCollage, setIdCollage] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const getCols = (width) => {
        if (width >= 1200) return 12;
        if (width >= 768) return 8;
        if (width >= 480) return 6;
        return 4;
    };

    const [cols, setCols] = useState(getCols(window.innerWidth)); // Устанавливаем начальное количество колонок



    const API_IMAGES_LIST = "/imagesList"; // Путь к API, который возвращает список изображений
    const API_COLLAGE_READ = "/collagesRead"; // Путь к API для чтения данных коллажа

    

    // Функция для запроса данных коллажа
    const fetchCollageData = async () => {
        const token = getToken();
    
        const idAsNumber = parseInt(params.id, 10);
    
        try {
            const response = await fetch(`${HOST}${API_COLLAGE_READ}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify({ id: idAsNumber }),
            });
    
            if (response.ok) {
                const data = await response.json();
    
                // Обновление layout из блоков
                if (data.Row && Array.isArray(data.Row.Blocks)) {
                    const layout = data.Row.Blocks.map(block => ({
                        i: block.id,  // id блока (уникальный идентификатор)
                        x: block.x,   // координаты блока по оси X
                        y: block.y,   // координаты блока по оси Y
                        w: block.w,   // ширина блока
                        h: block.h,   // высота блока
                    }));
    
                    // Обновляем состояние layout

                    setLayouts({
                        lg: layout,  // Assuming 'lg' as default for large screen size
                        // You can add other breakpoints here
                    });
                    setLayout(layout);
                    setxLayout(layout);
    
                    // Обновляем состояние images с изображениями блоков
                    const images = data.Row.Blocks.reduce((acc, block) => {
                        acc[block.id] = block.image;  // сохраняем ссылку на изображение
                        return acc;
                    }, {});
    
                    setImages(images);
                }
            } else {
                console.error("Failed to load collage data");
            }
        } catch (error) {
            console.error("Error fetching collage data:", error);
        }
    };    

    // Функция для запроса изображений с сервера
    const fetchImages = async (page) => {
        setLoading(true);
        const token = getToken();

        try {
            const response = await fetch(`${HOST}${API_IMAGES_LIST}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify({ Page: page }),
            });

            if (response.ok) {
                const data = await response.json();
                setGalleryImages(data.List.map(image => image.Name)); // Извлекаем только имена изображений
            } else {
                console.error("Failed to load images");
            }
        } catch (error) {
            console.error("Error fetching images:", error);
        } finally {
            setLoading(false);
        }
    };

    // Эффект для загрузки данных коллажа при монтировании компонента
    useEffect(() => {
        if (params.id) {
            const idAsNumber = parseInt(params.id, 10);
            setIdCollage(idAsNumber)
        }

        fetchCollageData(); // Загружаем данные коллажа при старте
    }, []);  // Эффект срабатывает только один раз при монтировании компонента

    useEffect(() => {
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
          setCols(getCols(window.innerWidth)); // Обновляем количество колонок при изменении ширины окна
        };
    
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);    

    // Эффект для загрузки изображений при открытии модального окна или изменении страницы
    useEffect(() => {
        if (isModalOpen) {
            fetchImages(currentPage); // Загружаем изображения при открытии модального окна
        }
    }, [isModalOpen, currentPage]);  // Эффект срабатывает при изменении isModalOpen или currentPage

    const onLayoutChange = useCallback((newLayout, allLayouts) => {
        setLayouts((prevLayouts) => ({
            ...prevLayouts,
            ...allLayouts,  // Merge all layouts for each breakpoint
        }));

        console.log(allLayouts)

        setLayout(newLayout);
    }, []);

    const addNewItem = () => {
        const newId = uuidv4(); // Генерируем уникальный id
        setNewItemId(newId);
        setIsModalOpen(true);  // Открываем модальное окно для выбора изображения
    };

    const handleImageSelect = (imageUrl) => {
        setNewItemImage(imageUrl);  // Сохраняем выбранное изображение
        setUploadedImage(null);  // Очищаем состояние для локальных изображений
    };

    const handleFileChange = async (event) => {
        const files = event.target.files; // Массив выбранных файлов
        if (files.length > 0) {
            const token = getToken();
    
            // Функция для отправки частей файла
            const uploadChunk = async (file, chunk, chunkIndex, totalChunks, chunkSize) => {
                try {
                    const response = await fetch(`${HOST}/filesUploadChunk`, {
                        method: 'POST',
                        headers: {
                            'Authorization': token,
                            'X-Filename': btoa(file.name),
                            'X-Chunk-Total': totalChunks,
                            'X-Chunk-Number': chunkIndex,
                        },
                        body: chunk,
                    });
    
                    if (response.ok) {
                        console.log(`Part ${chunkIndex + 1} of file ${file.name} uploaded successfully. ${totalChunks}`);
                        if (chunkIndex + 1 < totalChunks) {
                            // Если есть еще части для загрузки, продолжаем загружать
                            const offset = (chunkIndex + 1) * chunkSize;
                            const nextChunk = file.slice(offset, offset + chunkSize);

                            console.log(`Part ${chunkIndex + 1} of file ${file.name} uploaded successfully. ${totalChunks} ${offset} ${nextChunk}`);

                            uploadChunk(file, nextChunk, chunkIndex + 1, totalChunks, chunkSize);
                        } else {
                            // Все части файла загружены, получаем ответ
                            const data = await response.json();
                            const imageUrl = data.imageUrl;
                            setUploadedImage(imageUrl); // Сохраняем URL загруженного изображения
                        }
                    } else {
                        console.error('Failed to upload chunk');
                    }
                } catch (error) {
                    console.error('Error uploading chunk:', error);
                }
            };
    
            // Проходим по каждому файлу и начинаем загрузку его частей
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const chunkSize = 100 * 1024; // Размер части (100 КБ)
                const totalChunks = Math.ceil(file.size / chunkSize); // Общее количество частей
                let offset = 0; // Начальная позиция для каждой части
    
                // Начинаем загружать файл с первой части
                const firstChunk = file.slice(offset, offset + chunkSize);
                uploadChunk(file, firstChunk, 0, totalChunks, chunkSize);
            }
        }
    };
    

    const handleAddItemWithImage = () => {
        if (newItemImage || uploadedImage) {
            const newItem = {
                i: newItemId,
                x: (layout.length * 3) % 12,
                y: Infinity,
                w: 2,
                h: 2
            };

            const imageToAdd = newItemImage || uploadedImage;
            const fullImagePath = imageToAdd.startsWith('http') ? imageToAdd : `${HOST}/filesRead/${imageToAdd}`;

            setLayout((prevLayout) => [...prevLayout, newItem]);
            setxLayout((prevLayout) => [...prevLayout, newItem]);
            setImages((prevImages) => ({
                ...prevImages,
                [newItemId]: fullImagePath,
            }));

            setIsModalOpen(false);
            setNewItemImage(null);
            setUploadedImage(null);
        }
    };

    const handleRemoveItem = (itemId) => {
        setLayout((prevLayout) => prevLayout.filter((item) => item.i !== itemId));
        setxLayout((prevLayout) => prevLayout.filter((item) => item.i !== itemId));
        setImages((prevImages) => {
            const newImages = { ...prevImages };
            delete newImages[itemId];
            return newImages;
        });
    };

    const filteredImages = galleryImages.filter((imageUrl) =>
        imageUrl.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const generateDOM = () => {
        return layout.map((item) => {
            const imageUrl = images[item.i];
            return (
                <div
                    key={item.i}
                    style={{
                        position: "relative",
                        background: "lightblue",
                        border: "1px solid black",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        overflow: "hidden",
                        margin: "10px"
                    }}
                >
                    <img
                        src={imageUrl}
                        alt={`Item ${item.i}`}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: -1,
                        }}
                    />
                    <span
                        style={{
                            zIndex: 1,
                            position: "relative",
                        }}
                    >
                        Item {item.i}
                    </span>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveItem(item.i);
                        }}
                        style={{
                            position: "absolute",
                            top: 5,
                            right: 5,
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "5px",
                            zIndex: 2,
                        }}
                    >
                        Delete
                    </button>
                </div>
            );
        });
    };

    const sendDataToServer = async () => {
        const data = layout.map((item) => ({
            id: item.i,
            x: item.x,
            y: item.y,
            w: item.w,
            h: item.h,
            image: images[item.i]
        }));

        const token = getToken();

        try {
            const response = await fetch(`${HOST}/collagesUpdate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': token,
                },
                body: JSON.stringify({
                    id: idCollage,
                    blocks: data
                }),
            });

            if (response.ok) {
                console.log("Data successfully sent to server");
            } else {
                console.error("Failed to send data to server");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <div>

            <div style={{paddingTop: '20px'}}>
                <Breadcrumb
                    separator=""
                    items={[
                        {
                            href: '/',
                            title: <HomeOutlined />,
                        },
                        {
                            type: 'separator',
                        },                    
                        {
                            href: '/galleries',
                            title: 'Галлереи',
                        },
                        {
                            type: 'separator',
                        },
                        {
                            href: `/gallery/${params.id}/collages`,
                            title: 'Коллажи',
                        }
                    ]}
                />
            </div>        

            <Divider />

            <Flex gap="small" wrap="wrap">
            <Link>
                <Button type="primary" icon={<PlusCircleOutlined />} size='large' onClick={addNewItem} />
            </Link>
            <Button 
                type="primary" 
                icon={<DeleteOutlined />} 
                size='large' 
                onClick={sendDataToServer}
            />
            </Flex>

            <Divider />

            <ResponsiveReactGridLayout
                layouts={{ lg: layout }}
                onLayoutChange={onLayoutChange}
                
                breakpoints={{ lg: 1200 }}
                cols={{ lg: 12, md: 8, sm: 6, xs: 4 }}
                resizeHandles={['se', 'ne', 'sw', 'nw']}

                /*
                breakpoints={{ lg: 1200, md: 768, sm: 480, xs: 0 }}
                cols={{ lg: 12, md: 8, sm: 6, xs: 4 }}                 
                resizeHandles={['se', 'ne', 'sw', 'nw']}
                */

                {...props}
            >
                {generateDOM()}
            </ResponsiveReactGridLayout>

            {isModalOpen && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}>
                    <div style={{
                        backgroundColor: "white",
                        padding: "20px",
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "80%",
                        maxWidth: "800px"
                    }}>
                        <h3>Select an image for the new block</h3>
                        <input
                            type="text"
                            placeholder="Search images"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{ marginBottom: "10px", padding: "5px 10px" }}
                        />
                        {loading ? (
                            <p>Loading images...</p>
                        ) : (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                                {filteredImages.map((imageName, index) => (
                                    <img
                                        key={index}
                                        src={`${HOST}/filesRead/${imageName}`}
                                        alt={`Gallery Image ${index}`}
                                        onClick={() => handleImageSelect(imageName)}
                                        style={{
                                            width: "100px",
                                            height: "100px",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                            border: "2px solid #ddd",
                                            borderRadius: "8px",
                                        }}
                                    />
                                ))}
                            </div>
                        )}
                        
                        <input
                            type="file"
                            onChange={handleFileChange}
                            multiple
                            accept="image/*"
                            style={{ marginTop: "10px" }}
                        />
                        {uploadedImage && (
                            <div style={{ marginTop: "10px" }}>
                                <img
                                    src={uploadedImage}
                                    alt="Uploaded"
                                    style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                                />
                            </div>
                        )}

                        <div style={{ marginTop: "10px" }}>
                            <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 0}>
                                Previous
                            </button>
                            <span style={{ margin: "0 10px" }}>
                                Page {currentPage + 1}
                            </span>
                            <button onClick={() => paginate(currentPage + 1)}>
                                Next
                            </button>
                        </div>

                        <button onClick={handleAddItemWithImage} style={{ marginTop: "10px" }}>
                            Add Block with Image
                        </button>
                        <button onClick={() => setIsModalOpen(false)} style={{ marginTop: "10px", backgroundColor: "red", color: "white" }}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CollageEdit;
